import {Location, History} from "history";




export function goBackUntil(history: History, condition: (location: Location) => boolean) {
    return new Promise<void>((resolve, reject) => {
        const dispose = history.listen((location, action) => {
            if (action == "POP") {
                if (condition(location)) {
                    history.goBack();
                } else {
                    dispose();
                    resolve();
                }
            } else {
                reject(new Error("history was changed during the goBackUntil"))
            }
        });

        if (condition(history.location)) {
            history.goBack();
        } else {
            dispose();
            resolve();
        }
    })
}